/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserCouponHistoryRespVo } from './UserCouponHistoryRespVo';
import {
    UserCouponHistoryRespVoFromJSON,
    UserCouponHistoryRespVoFromJSONTyped,
    UserCouponHistoryRespVoToJSON,
    UserCouponHistoryRespVoToJSONTyped,
} from './UserCouponHistoryRespVo';

/**
 * 
 * @export
 * @interface PageDataUserCouponHistoryRespVo
 */
export interface PageDataUserCouponHistoryRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserCouponHistoryRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserCouponHistoryRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserCouponHistoryRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserCouponHistoryRespVo>}
     * @memberof PageDataUserCouponHistoryRespVo
     */
    records?: Array<UserCouponHistoryRespVo>;
}

/**
 * Check if a given object implements the PageDataUserCouponHistoryRespVo interface.
 */
export function instanceOfPageDataUserCouponHistoryRespVo(value: object): value is PageDataUserCouponHistoryRespVo {
    return true;
}

export function PageDataUserCouponHistoryRespVoFromJSON(json: any): PageDataUserCouponHistoryRespVo {
    return PageDataUserCouponHistoryRespVoFromJSONTyped(json, false);
}

export function PageDataUserCouponHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserCouponHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserCouponHistoryRespVoFromJSON)),
    };
}

export function PageDataUserCouponHistoryRespVoToJSON(json: any): PageDataUserCouponHistoryRespVo {
    return PageDataUserCouponHistoryRespVoToJSONTyped(json, false);
}

export function PageDataUserCouponHistoryRespVoToJSONTyped(value?: PageDataUserCouponHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserCouponHistoryRespVoToJSON)),
    };
}

